import lodashUniqBy from 'lodash/fp/uniqBy';

import {
  SR_API_ACTION_GET_LISTING_LIST,
} from 'api/actionTypes';

export default function getListingsForViewingTour({ state, apiClient }) {
  const { viewingTour, viewingRenter } = state.get(['agentMapView']);

  return apiClient.postWithState({
    action: SR_API_ACTION_GET_LISTING_LIST,
    state: state,
    payload: {
      page: 0,
      count: 100,
      filters: {
        ...viewingRenter.searchFilters,
        locationPoint: state.get(['agentMapView', 'mapArea']),
      },
    },
    onSuccess: ({ data }) => {
      const newRecords = lodashUniqBy('id', [ ...data, ...viewingTour.listings ]);
      state.set(['agentMapView', 'listings'], newRecords);
    },
  });
}
